<section class="flex min-h-0 flex-1 flex-col gap-6 px-1 pb-4">
  @if (contextLabel(); as label) {
    <p class="text-center text-xs font-medium uppercase tracking-wide text-[#7a6b8a]">
      {{ label }}
    </p>
  }

  <article
    class="flex flex-1 flex-col items-center justify-center gap-4 rounded-2xl border border-[#ece4f3] bg-[#faf7fc] px-5 py-8 text-center"
  >
    <span
      class="inline-flex h-16 w-16 items-center justify-center rounded-full bg-white text-[#5a2f6b] shadow-sm"
      [class.animate-pulse]="phase() === 'recording'"
      aria-hidden="true"
    >
      <span class="material-icons text-[36px]">
        {{ phase() === "recording" ? "graphic_eq" : "mic" }}
      </span>
    </span>

    <div class="max-w-sm space-y-2">
      <p class="text-sm font-semibold text-[#3d2652]">
        {{ "mobile.voiceReport.recorder.infoTitle" | translate }}
      </p>
      <p class="text-xs leading-relaxed text-[#7a6b8a]">
        {{ "mobile.voiceReport.recorder.infoBody" | translate }}
      </p>
    </div>

    @if (phase() === "recording") {
      <p class="font-mono text-lg font-semibold tabular-nums text-[#5a2f6b]" aria-live="polite">
        {{ formatElapsed() }}
      </p>
      <p class="text-xs text-[#7a6b8a]">{{ "mobile.voiceReport.recorder.recordingHint" | translate }}</p>
    }

    @if (phase() === "processing") {
      <div class="flex flex-col items-center gap-2">
        <span class="material-icons animate-spin text-[#5a2f6b]" aria-hidden="true">progress_activity</span>
        <p class="text-xs text-[#7a6b8a]">{{ "mobile.voiceReport.recorder.processingHint" | translate }}</p>
      </div>
    }

    @if (micDenied()) {
      <p class="text-xs text-destructive">{{ "mobile.voiceReport.recorder.error.micDenied" | translate }}</p>
    }
  </article>

  <div class="mt-auto flex flex-col gap-2">
    <button
      type="button"
      class="flex min-h-[3rem] w-full items-center justify-center gap-2 rounded-xl bg-[#5a2f6b] px-4 py-3 text-sm font-semibold text-white shadow-sm active:scale-[0.98] disabled:cursor-not-allowed disabled:opacity-60"
      [disabled]="phase() === 'processing' || micDenied()"
      (click)="onPrimaryAction()"
    >
      <span class="material-icons text-[22px]" aria-hidden="true">{{ primaryIcon() }}</span>
      {{ primaryLabelKey() | translate }}
    </button>
  </div>
</section>
